import React from "react";
import { array, bool, object, string } from "prop-types";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import StoryMetaData from "../StoryMetaData";

import "./photo-story-card.m.css";

const PhotoStoryCard = ({
  story,
  imageType,
  aspectRatio,
  headlineSponsor,
  className = "",
  widths = [250, 480, 764],
}) => {
  if (!story) return null;

  return (
    <div styleName="base" className={`photo-story-card ${className}`}>
      <CardImage
        className="card-with-image-zoom"
        story={story}
        aspectRatio={aspectRatio}
        imageType={imageType}
        linkEnable={true}
        widths={widths}
      />
      <div styleName="card-content" className="photo-story-card-headline">
        <NewsHeadline story={story} showSponsor={headlineSponsor} />
        <StoryMetaData story={story} />
      </div>
    </div>
  );
};

PhotoStoryCard.propTypes = {
  story: object.isRequired,
  imageType: string,
  aspectRatio: array,
  className: string,
  headlineSponsor: bool,
  widths: object,
};

export default PhotoStoryCard;
